export type RoboyuCustomColorTheme =
  | 'blue'
  | 'red'
  | 'light_blue'
  | 'yellow'
  | 'orange'
  | 'pink'
  | 'green'
  | 'purple'

export type RoboyuSelectableColorTheme = RoboyuCustomColorTheme | 'default'

export interface RoboyuColorScheme {
  face_body_1?: string
  face_body_2?: string
  face_body_outline?: string
  eyes?: string
  heart_hair_1?: string
  heart_hair_2?: string
  emoji_1?: string
  emoji_2?: string
  emoji_3?: string
  emoji_eye_mouth?: string
}

export type RoboyuTheme = {
  [key in RoboyuSelectableColorTheme]: RoboyuColorScheme
}

export const RoboyuColorTheme: RoboyuTheme = {
  default: {
    face_body_1: '#35378E',
    face_body_2: '#272667',
    face_body_outline: '#1E1C57',
    eyes: '#6CCFF3',
    heart_hair_1: '#EF529D',
    heart_hair_2: '#D3267A',
    emoji_1: '#B4C6F3',
    emoji_2: '#E8EFFF',
    emoji_3: '#79A4F5',
    emoji_eye_mouth: '#3C517E',
  },
  blue: {
    face_body_1: '#35378E',
    face_body_2: '#272667',
    face_body_outline: '#1E1C57',
    eyes: '#6CCFF3',
    heart_hair_1: '#EF529D',
    heart_hair_2: '#D3267A',
    emoji_1: '#B4C6F3',
    emoji_2: '#E8EFFF',
    emoji_3: '#79A4F5',
    emoji_eye_mouth: '#3C517E',
  },
  red: {
    face_body_1: '#DA1F26',
    face_body_2: '#C62026',
    face_body_outline: '#80151A',
    eyes: '#FFD700',
    heart_hair_1: '#FF8C00',
    heart_hair_2: '#D45F00',
    emoji_1: '#FFA5A8',
    emoji_2: '#FFD2D4',
    emoji_3: '#FF868A',
    emoji_eye_mouth: '#7B2023',
  },
  light_blue: {
    face_body_1: '#6B78FF',
    face_body_2: '#4F5BCC',
    face_body_outline: '#3A4699',
    eyes: '#00FFFF',
    heart_hair_1: '#FF85A2',
    heart_hair_2: '#D64F7A',
    emoji_1: '#B3B8EC',
    emoji_2: '#EFF0FF',
    emoji_3: '#99A2FE',
    emoji_eye_mouth: '#3E4589',
  },
  yellow: {
    face_body_1: '#FCD319',
    face_body_2: '#D8A628',
    face_body_outline: '#B7832C',
    eyes: '#FFFFFF',
    heart_hair_1: '#EF529D',
    heart_hair_2: '#D3267A',
    emoji_1: '#FEE674',
    emoji_2: '#FEF0B2',
    emoji_3: '#FFCE74',
    emoji_eye_mouth: '#AB8A4E',
  },
  orange: {
    face_body_1: '#FF8800',
    face_body_2: '#E07B00',
    face_body_outline: '#B65E00',
    eyes: '#FFD700',
    heart_hair_1: '#E12000',
    heart_hair_2: '#8E0000',
    emoji_1: '#FFC98C',
    emoji_2: '#FFE7CC',
    emoji_3: '#FBB564',
    emoji_eye_mouth: '#A87942',
  },
  pink: {
    face_body_1: '#FF1493',
    face_body_2: '#D10078',
    face_body_outline: '#960057',
    eyes: '#00FFFF',
    heart_hair_1: '#37E516',
    heart_hair_2: '#008F11',
    emoji_1: '#FF8FCC',
    emoji_2: '#FFD3EB',
    emoji_3: '#FF80C4',
    emoji_eye_mouth: '#892059',
  },
  green: {
    face_body_1: '#32CD32',
    face_body_2: '#228B22',
    face_body_outline: '#126514',
    eyes: '#CCF0FF',
    heart_hair_1: '#FF1493',
    heart_hair_2: '#C71585',
    emoji_1: '#87E587',
    emoji_2: '#F6FFF6',
    emoji_3: '#5FDF5F',
    emoji_eye_mouth: '#2D7B2D',
  },
  purple: {
    face_body_1: '#9400D3',
    face_body_2: '#6A00A5',
    face_body_outline: '#460072',
    eyes: '#00FFFF',
    heart_hair_1: '#FF1493',
    heart_hair_2: '#C71585',
    emoji_1: '#D69BDD',
    emoji_2: '#F9E0F8',
    emoji_3: '#AF75BC',
    emoji_eye_mouth: '#7E4890',
  },
}

export interface RoboyuState {
  lv: number
  exp: number
  colorTheme: RoboyuSkin
}

export interface RoboyuSkin {
  name: RoboyuSelectableColorTheme
  skin_id: string
}

export interface RoboyuSkinResponse {
  lv: number
  exp: number
  skin_id: string
  skin_name: RoboyuSelectableColorTheme
}
